import { useEffect } from 'react';
import './ShoppingTerms.css';
import Header from './Header';
import Footer2 from './Footer2';
import { ToastContainer, toast } from 'react-toastify';
// import axios from 'axios';
import React, { useRef, useState } from 'react'

const ShoppingTerms = () => {
    // const [formData, setFormData] = useState({
    //     Contact_Name: '',
    //     Contact_Email: '',
    //     Phone_Number: '',
    //     Contact_Message: ''
    // });

    // const handleChange = (e) => {
    //     setFormData({
    //         ...formData,
    //         [e.target.name]: e.target.value
    //     });
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email format regex
    //     const phoneRegex = /^[0-9]{10}$/; // 10-digit phone format

    //     if (!formData.Contact_Name.trim()) {
    //         toast.error("Please enter your name.");
    //         return;
    //     }

    //     if (!formData.Contact_Email.trim()) {
    //         toast.error("Please enter your email.");
    //         return;
    //     }

    //     if (!emailRegex.test(formData.Contact_Email)) {
    //         toast.error("Please enter a valid email address.");
    //         return;
    //     }

    //     if (!formData.Phone_Number.trim()) {
    //         toast.error("Please enter your phone number.");
    //         return;
    //     }

    //     if (!phoneRegex.test(formData.Phone_Number)) {
    //         toast.error("Please enter a valid 10-digit phone number.");
    //         return;
    //     }

    //     if (!formData.Contact_Message.trim()) {
    //         toast.error("Please enter your message.");
    //         return;
    //     }


    //     try {
    //         await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/contact`, formData);
    //         toast.success('Thank you for contacting!');
    //         setFormData({
    //             Contact_Name: '',
    //             Contact_Email: '',
    //             Phone_Number: '',
    //             Contact_Message: ''
    //         });
    //     } catch (error) {
    //         toast.error('Failed to send message.');
    //         console.error(error);
    //     }
    // };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const terms = [
        { title: "Get in Touch", content: "Please fill out the form below with the details of your project. To help us understand your vision, please be as descriptive as possible." },
        { title: "The Process", content: "Once we accept your request and finalize the project details, we will begin working together." },
        { title: "Payment Terms", content: "A 50% initial deposit is required to begin. The remaining balance must be paid in full once the piece is completed." },
        { title: "Custom Pricing", content: "Pricing for each commission is determined on an individual basis, depending on the level of detail, size, shape, and category." },
        { title: "Payment Methods", content: "At this time, we only accept online payment modes." },
        { title: "References", content: "Please note that all pieces in the gallery and store were created for individual clients. When using these as references, please be specific about any changes or unique details you would like for your own order." }
    ];

    return (
        <>
            <Header />

            
            <div className="shopping-terms-wrapper">
                <div className="container">
                    <div className="terms-inner-container">
                        <h1 className="terms-main-title">Shopping Terms</h1>

                        {terms.map((item, index) => (
                            <div key={index} className="terms-item-block">
                                <h3 className="terms-sub-heading">{item.title}</h3>
                                <p className="terms-description-text">{item.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
    
            <Footer2 />
        </>
    );
};

export default ShoppingTerms;